// First-party
import { createPage } from '@/common/util/templateHelpers';

// Component lib
import { Meta } from '@/common/components/head';

// Local
import { Block, Content, Title } from '@/common/components';
import AboutPageLayout from '@/layouts/AboutPageLayout';
import { useRouter } from 'next/router';

export default createPage('AboutUsPage', {}, function AboutUsPage ({ className }) {

  const router = useRouter();

  const pageDescription = 'Addicting Games is the largest online games site in the US. Reaching over 10 million unique users every month (comScore). We are considered founders in the casual game territory, developing and distributing innovative, irreverent, addictive online games since the early 2000s. Addicting Games has a long history of working closely with game developers to provide one of the';
  const ogDescription = 'Addicting Games is the largest online games site in the US. Reaching over 10 million unique users every month (comScore). We are considered founders in the casual game territory, developing and distributing innovative, irreverent, addictive online games since the early 2000s. Addicting Games has a long history of working closely with game developers to provide one of the largest ranges of free online games including action games, sports games, puzzle games, IO games, mobile games and many more.';
  const twitterDescription = 'Addicting Games is the largest online games site in the US. Reaching over 10 million unique users every month (comScore). We are considered founders in the casual game territory, developing and';

  const metaProps = {
    itemDescription: pageDescription,
    description: pageDescription,
    openGraph: {
      url: process.env.APP_CONFIG.URL + '/about/about-us',
      description: ogDescription,
      updated_time: '2021-10-05T12:12:26-07:00',
      'article:published_time': '2021-10-05T12:09:43-07:00',
      'article:modified_time': '2021-10-05T12:12:26-07:00',
    },
    twitter: {
      description: twitterDescription
    }
  };
  
  return (
    <AboutPageLayout className={className}>
      <Meta 
        title='About Addicting Games'
        titleTag='About Addicting Games | Addicting Games' 
        {...metaProps}
      />

      <Block>
        <Title>About Addicting Games</Title>

        <Content>
          <p>Addicting Games is the largest online games site in the US. Reaching over 10 million unique users every month (comScore). We are considered founders in the casual game territory, developing and distributing innovative, irreverent, addictive online games since the early 2000s. Addicting Games has a long history of working closely with game developers to provide one of the largest ranges of free online games including action games, sports games, puzzle games, IO games, mobile games and many more. We release new games every Thursday and update features daily based on what's trending and what our users are telling us about.</p>
          <p><strong>WHAT WE DO AT ADDICTING GAMES</strong></p>
          <p>Listen to our diverse group of Patrons… Offering the best casual games possible requires core, commitment, and dedication. We believe in the potential of every individual. At Addicting Games, we promote diversity in all realms of humanity, culture, lifestyle, age, background, experience, religion, socioeconomic status, gender identity, and marital status. Listening to all the feedback we receive daily, staying grounded and being open to new ways of thinking allows us to stay relevant and provide the absolute best and most creative content. Addicting Games players know what they like. We make it easy for them to tell us, with reviews, ratings, favorites, and our social media platforms. Feel free to visit us at&nbsp;<a href="https://www.facebook.com/AddictingGames/">Facebook AG</a>,&nbsp;<a href="https://twitter.com/AddictingGames">Twitter AG</a>, and&nbsp;<a href="https://www.instagram.com/theofficialaddictinggames/">Instagram AG</a>.</p>
          <p><strong>NEW GAMES</strong></p>
          <p>
          Addicting Games launches more than a dozen new games every week. We present games from hundreds of independent developers, spread around the globe. Patrons can play as much as they want, anytime, anywhere, on any internet-connected devices.</p>
          <p>
            <strong>INNOVATE</strong></p>
          <p>
          Addicting Games was built on innovation. The idea was simple: get great games on our site! Striving to bring imagination, original ideas, and excitement to everything we do. Addicting Games has produced titles like Fratboy Girlfriend TD, Pencil Racer, and 50 States. We seek out new game concepts and foster experimental game ideas. Displaying the courage and curiosity it requires to be a leader in the casual gaming space.</p>
          <p>
            <strong>LEAD THE WAY</strong></p>
          <p>
          Addicting Games was a pioneer in the online game space. We have come a long way and have refined our trade over the years. We are proud to represent games and developers that break the mold and redefine online games. Committed to each other, and to the integrity and accountability required to be a successful team. Through sponsorships, game licensing, and development deals, we offer an infinite amount of ways to collaborate with us.&nbsp;</p>
          <p><strong>FUN FACTS</strong></p>
          <ul>
            <li>Addicting Games is an industry leader in publishing casual games online and has been since 2002</li>
            <li>We are one of the first gaming portals on the internet</li>
            <li>Our games have raked in hundreds of millions of plays over the last 17+ years</li>
            <li>For over seven years we proudly displayed our logo in Comic Sans</li>
            <li>A library of over four thousand classic games as well as new games added every week</li>
            <li>"Addictive Games" would technically be grammatically correct but less fun</li>
          </ul>
        </Content>
      </Block>
    </AboutPageLayout>
  );
});
